"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./delivery-query.service"));
__export(require("./mapping.service"));
//# sourceMappingURL=index.js.map